export default "https://assets.egbcdn.net/assets/packs/_/images/hidden_temple_ru-5ce684a9ac933d3623de2035c85fc25c.jpg";